import { isOnlyApiUser, isSelfService } from 'helpers/Authentication';

const COMPANIES = '/companies/';

export const routes = {
  api_dashboard_documents: COMPANIES + 'api_dashboard_documents',
  dashboard: COMPANIES + 'dashboard',
  calendar_kiosk: COMPANIES + 'calendar_kiosk',
};

export function dashboardForAgent(permissions) {
  if (isOnlyApiUser(permissions)) {
    return routes.api_dashboard_documents;
  } else if (isSelfService(permissions)) {
    return routes.calendar_kiosk;
  } else {
    return routes.dashboard;
  }
}
